(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["collection-filter-bar"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('collection-filter-bar')) {
    customElements.define(
      'collection-filter-bar',
      class CollectionFilterBar extends HTMLElement {
        connectedCallback() {
          this.productSection = this.closest('.shopify-section');
          if (!this.productSection) return;

          this.items = Array.from(this.productSection.querySelectorAll('.resource-list__item'));
          this.itemContainer = this.items[0]?.parentElement;
          this.products = JSON.parse(this.querySelector('[data-product-filter-data]')?.textContent || '[]');
          this.productMap = new Map(this.products.map((product) => [String(product.id), product]));

          this.filterButtons = Array.from(this.querySelectorAll('[data-product-filter]'));
          this.mobileFilter = this.querySelector('[data-mobile-product-filter]');

          this.filterButtons.forEach((button) => {
            button.addEventListener('click', () => this.filter(button));
          });

          this.filterButtons.forEach((button, index) => {
            const option = document.createElement('option');
            option.value = String(index);
            option.textContent = button.textContent.trim();
            option.selected = button.classList.contains('is-active');
            this.mobileFilter?.appendChild(option);
          });

          this.mobileFilter?.addEventListener('change', (event) => {
            const button = this.filterButtons[Number(event.target.value)];
            if (button) this.filter(button);
          });

          this.querySelector('[data-product-sort]')?.addEventListener('change', (event) => {
            this.sort(event.target.value);
          });
        }

        itemId(item) {
          return String(item.querySelector('product-card')?.dataset.productId || '');
        }

        filter(activeButton) {
          const allowedIds = new Set(
            (activeButton.dataset.productIds || '').split(',').filter(Boolean)
          );

          this.querySelectorAll('[data-product-filter]').forEach((button) => {
            button.classList.toggle('is-active', button === activeButton);
          });

          if (this.mobileFilter) {
            this.mobileFilter.value = String(this.filterButtons.indexOf(activeButton));
          }

          this.items.forEach((item) => {
            item.hidden = !allowedIds.has(this.itemId(item));
          });
        }

        sort(mode) {
          if (!this.itemContainer) return;

          const sortedItems = [...this.items].sort((itemA, itemB) => {
            const a = this.productMap.get(this.itemId(itemA)) || {};
            const b = this.productMap.get(this.itemId(itemB)) || {};

            switch (mode) {
              case 'title-ascending':
                return String(a.title || '').localeCompare(String(b.title || ''), 'de');
              case 'title-descending':
                return String(b.title || '').localeCompare(String(a.title || ''), 'de');
              case 'price-ascending':
                return Number(a.price || 0) - Number(b.price || 0);
              case 'price-descending':
                return Number(b.price || 0) - Number(a.price || 0);
              case 'created-descending':
                return Number(b.created || 0) - Number(a.created || 0);
              default:
                return Number(a.order || 0) - Number(b.order || 0);
            }
          });

          sortedItems.forEach((item) => this.itemContainer.appendChild(item));
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["visible-product-count"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('visible-product-count')) {
    customElements.define(
      'visible-product-count',
      class VisibleProductCount extends HTMLElement {
        connectedCallback() {
          this.section = this.closest('.shopify-section');
          if (!this.section) return;

          this.update = this.update.bind(this);
          this.observer = new MutationObserver(this.update);
          this.observer.observe(this.section, {
            childList: true,
            subtree: true,
            attributes: true,
            attributeFilter: ['hidden', 'style', 'class'],
          });

          requestAnimationFrame(this.update);
        }

        disconnectedCallback() {
          this.observer?.disconnect();
        }

        update() {
          const items = Array.from(this.section.querySelectorAll('.resource-list__item'));
          if (!items.length) return;

          const visibleItems = items.filter((item) => !item.hidden && item.style.display !== 'none');
          const count = visibleItems.length;

          const countElement = this.querySelector('[data-visible-product-count]');
          const labelElement = this.querySelector('[data-visible-product-label]');
          const label = count === 1 ? 'Produkt' : 'Produkte';

          if (countElement.textContent !== String(count)) countElement.textContent = count;
          if (labelElement.textContent !== label) labelElement.textContent = label;
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
